function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M11.999 10.584L7.787 6.373l-.089-.079c-.409-.312-.97-.276-1.325.079l-.079.089-.07.105c-.234.396-.176.895.149 1.22l4.211 4.211-4.211 4.213-.079.089c-.312.409-.276.97.079 1.325l.089.079.105.07c.396.234.895.176 1.22-.149L12 13.412l4.212 4.213.089.079c.409.312.97.276 1.325-.079l.079-.089.07-.105c.234-.396.176-.895-.149-1.22l-4.212-4.213 4.212-4.21.079-.09c.312-.409.276-.97-.079-1.325l-.102-.09c-.396-.3-.957-.265-1.312.09l-4.212 4.211z",
  transform: "translate(-709 -35) translate(706 32) translate(3 3)"
})))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/x.ca836869.svg";
export { SvgComponent as ReactComponent };